import { useLocalSearchParams } from 'expo-router';

import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  const { productSlug } = useLocalSearchParams<{ productSlug: string }>();

  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>Search Location — {productSlug}</ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton
        href={`/(modals)/order-product/${productSlug}` as never}
        dismiss
      />
    </ExpoRouterDemoScreen>
  );
}
